import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=5917e0cf&scoped=true"
import script from "./Colors.vue?vue&type=script&setup=true&lang=js"
export * from "./Colors.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Colors.vue?vue&type=style&index=0&id=5917e0cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5917e0cf",
  null
  
)

export default component.exports